<template>
  <v-row class="mt-0 mb-0 pt-0 pb-0">
    <v-col cols="12" :class="cmp_class" >
      <v-select
        max-height="40"
        height="30"
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        :small-chips="small_chips"
        autocomplete="on"
        :label="label"
        :prepend-inner-icon="icon"
        :disabled="disabled"
        v-model="local_value"
        :rules="validation_rules"
        :required="required"
        :items="options"
        :multiple="multiple"
        :chips="multiple"
        :validate-on-blur="true"
        :item-text="item_text"
        :item-value="item_value"
        :loading="is_loading_info"
      ></v-select>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: "SelectField",
  props: {
    item_text: {
      type: String,
      default: "text",
    },
    item_value: {
      type: String,
      default: "value",
    },
    label: {
      type: String,
      default: "select",
    },
    cmp_class: {
      type: String,
      default: "mt-0 mb-1 pb-0 pt-2",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    is_loading_info: {
      type: Boolean,
      default: false,
    },
    small_chips:{
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    icon: {
      type: String,
      default: "mdi-script-text-outline",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    required: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String,Number,Array],
      default: "",
    }
  },
  computed: {
    local_value: {
      get() {
        return this.value;
      },
      set(new_value) {
        this.$emit("change", { old_value: this.value, new_value: new_value  });
        this.$emit("input", new_value);
      },
    },
  },
};
</script>

<style scoped>
</style>